import { render } from "preact";
import { LazyCss } from "../components/css";

const P = ({ children }) => <p class="mt-6 md:text-xl text-lg leading-8">{children}</p>

const Quote = ({ children }) => <p class="mt-3 text-xl leading-8">
  <span class="text-4xl absolute -ml-5 -mt-1 opacity-40">&ldquo;</span>
  {children}<span class="text-4xl absolute ml-1 -mt-1 opacity-40">&rdquo;</span>
</p>

const Attribution = ({ children }) => <p class="ml-8 mt-2 mb-12 text-lg">&mdash; {children}</p>

const Link = ({ href, children }) => <a href={href} class="underline decoration-2 underline-offset-4 decoration-blue-300 hover:decoration-blue-500 transition">{children}</a>


const About = () => {
  return <div class="h-full bg-no-repeat text-white monorail-header">
      <LazyCss url="https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" />
      <LazyCss url="https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap" />

      <div class="pt-10 pb-40 md:p-20 md:pt-20 max-w-[1000px] mx-auto">

        <a href="/"><img class="px-6 md:px-10" src="/logo.png" alt="Monorail Technology logo" /></a>

        <div class="flex justify-self-start items-center flex-row-reverse md:my-14 my-10">

          <div class="text-3xl md:text-5xl bg-opacity-90 px-2 md:px-4 md:py-4 py-2 text-left leading-snug md:leading-normal">
            About Monorail
          </div>

          <div class="px-4 md:px-8">
            <img class="rounded-full max-w-28 md:max-w-32" src="/jesse.jpg" alt="Headshot of Jesse Kriss, a man with brown hair wearing a green shirt"/>
          </div>

        </div>

        <div class="text-2xl md:text-3xl bg-opacity-90 px-6 md:px-10 md:pb-4 pb-2 text-left font-normal md:leading-normal">
        <P>Monorail Technology is run by{" "}
          <a class="underline underline-offset-4 decoration-2 decoration-purple-300 hover:decoration-purple-500 transition" href="https://linkedin.com/in/jkriss" target="_blank">Jesse Kriss</a>,
          a pioneer in <Link href="https://www.kolide.com/blog/ufs-spotlight-jesse-kriss-of-netflix">user-focused security</Link> who has been making technology work for humans professionally since 1997.
        </P>
        <P>Jesse was the first security hire at <Link href="https://watershed.com">Watershed</Link>, where he built out the security, compliance, and IT programs and toolsets from scratch, carried them through multiple successful audits, and ensured that multiple Fortune 500 companies had high confidence in Watershed's security practices.
          Prior to Watershed, he spent 6.5 years on the security team at Netflix, widely known to be among the best in the business.
        </P>
        <P>
          Beyond Watershed and Netflix, Jesse has experience working at companies from 3 to 300,000 people including PricewaterhouseCoopers, IBM Research, the Obama 2012 Tech Team, and NASA/JPL, applying a range of skills including full stack web engineering, user centered design, information visualization, information security, infrastructure, technical leadership, and people management.
        </P>
        <P>
          Jesse holds a BA in Music from Carleton College, a Masters of Human-Computer Interaction from Carnegie Mellon, and is a Professional Certified Coach through New Ventures West.
        </P>
        <P>
          His work has won NASA’s Software of the Year award, IEEE VIS’s Test of Time Award, and a presidential election.
        </P>
        </div>

        <div class="text-2xl md:text-3xl bg-opacity-90 px-6 md:px-10 mt-6 md:py-4 py-2 text-left leading-snug md:leading-normal">
          Testimonials
        </div>

        <div class="text-2xl md:text-3xl bg-opacity-90 px-6 md:px-10 text-left font-normal md:leading-normal">
          <Quote>
            Jesse is a force of nature. He built Watershed's security and IT functions from the ground up, bringing us to Fortune 500 enterprise-ready in a remarkably short time. He left every team, customer, and function that he touched better than when he found it. I've never worked with anyone—in any function, at any company—that has scaled themselves as effectively as Jesse.
          </Quote>
          <Attribution>Matt Irwin, Watershed</Attribution>
        <Quote>
          Jesse is a wonderful advisor and partner on all matters security or infrastructure. He quickly discerns what is absolutely critical to solve in any situation, and adept at translating technical issues to non-technical audiences.
        </Quote>
        <Attribution>Katherine Tsai, Inflection AI</Attribution>
        <Quote>
          His brilliance in design, security, engineering, and usability is unparalleled, and his humanity is evident in his work and approach.
        </Quote>
        <Attribution>Rob McVey, Mandolin</Attribution>

        </div>
      </div>
    </div>
}

render(<About />, document.querySelector("main"));
